'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { buildChartOption } from './chart-option.js';
/**
 * Lazy ECharts mount for the db-table chart card (COP-114 §7, DBC-08).
 *
 * ECharts is loaded via ONE dynamic `import()` inside the effect — never a
 * static import — so consuming track bundles only pay for it when a
 * chart-bearing `data-db-table` part actually renders. hub-client compiles
 * with plain `tsc` (module NodeNext), which preserves the dynamic `import()`
 * for the consuming bundler to code-split. Deliberately NOT `React.lazy`:
 * the pre-load placeholder div below must survive `renderToStaticMarkup`.
 *
 * Unstyled. Consumers target `.copilot-db-chart` and `data-chart-type`.
 */
export function DbChartECharts({ type, columns, rows }) {
    const containerRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        let disposed = false;
        let chart = null;
        void (async () => {
            const echarts = await import('echarts');
            // Unmounted (or re-run) while the module was in flight — do not init.
            if (disposed)
                return;
            chart = echarts.init(container);
            chart.setOption(buildChartOption(type, columns, rows));
        })();
        return () => {
            disposed = true;
            chart?.dispose();
        };
    }, [type, columns, rows]);
    // Placeholder div pre-load / server-side; echarts.init takes over on mount.
    return (_jsx("div", { ref: containerRef, className: "copilot-db-chart", "data-chart-type": type, role: "img", "aria-label": `${type} chart` }));
}
//# sourceMappingURL=db-chart-echarts.js.map